import { styled, css, Box, BoxProps } from '@mui/material'
import { AppBodyProps, AppBodyStylesProps } from './AppBody.types'
import { getUnitValue } from '../../../utils/processStyles'

export const AppBodyWrapper = styled(Box, {
  name: 'AppBody'
})<BoxProps & AppBodyStylesProps>(
  ({ theme, padding, gap }) => css`
    overflow-x: hidden;
    overflow-y: auto;
    position: relative;
    flex: 1;
    gap: ${getUnitValue(gap)};
    padding: ${getUnitValue(padding)};

    ${theme.breakpoints.up('sm')} {
      &::-webkit-scrollbar {
        width: 4px;
        height: 4px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: ${theme.palette.primary.light};
        border-radius: 12px;
      }

      &::-webkit-scrollbar-thumb:hover {
        background-color: ${theme.palette.primary.main};
      }

      &::-webkit-scrollbar-track {
        background-color: transparent;
        border-radius: 12px;
      }
    }
  `
)

AppBodyWrapper.defaultProps = {
  padding: 8,
  gap: 12
}

export const AppBodyGrid = styled(Box)<AppBodyProps>(
  ({ gap }) => css`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    min-height: 100%;
    gap: ${getUnitValue(gap)};
  `
)
